import type { ImageProps } from 'next/image';
import type { Config } from '@packages/config';
import config from '@packages/config';
import { Image } from '@packages/shared/src/ui/Image/Image';

export type PaymentImageProps = Omit<ImageProps, 'src' | 'alt'> & {
  option: Config['paymentMethods']['imageBased'][number];
};

const altByOption: Record<Config['paymentMethods']['imageBased'][number], string> = {
  amex: 'American Express',
  clicktopay: 'Click to Pay',
  diners: 'Diners Club',
  discover: 'Discover',
  ideal: 'iDEAL',
  klarna_sofort: 'Klarna Sofort',
  mastercard: 'Mastercard',
  mastercard_clicktopay: 'Mastercard Click to Pay',
  paydirekt: 'Paydirekt',
  paypal: 'Paypal',
  visa: 'Visa',
  visa_clicktopay: 'Visa Click to Pay',
  wero: 'Wero',
};

export const PaymentImage = ({ option, width = 48, height = 32, ...args }: PaymentImageProps) => {
  const {
    assets: { assetServerHost },
  } = config;

  return (
    <Image
      src={`${assetServerHost}/i/empiriecom/${option}.svg`}
      alt={altByOption[option]}
      width={width}
      height={height}
      {...args}
    />
  );
};
